import { createApiClient } from '../../api';
import type { ScreenRules } from '../types';

import { parseScreenRules } from './schemas';

export const RULES_ENDPOINT = '/v2/rules';

const { request } = createApiClient();

export const fetchScreenRules = async (signal?: AbortSignal): Promise<ScreenRules> =>
  parseScreenRules(await request('get', RULES_ENDPOINT, { signal }));
